import './ConfiguracoesPage.css';
import Logo from '../Assets/dxpaylogo.png';
import SwichComponent from '../Component/swichComponent';
import { useContext, useReducer, useRef, useState } from 'react';
import { useAuth } from '../Contexts/AuthContext';
import TwoFactorModalLogin from '../Component/twoFactorModalLogin';

const LoginPage = () => {
    const [remember, setRemember] = useState(false);
    const { login, twoFaOpen, setTwofa } = useAuth();
    const [errorLogin,setErrorLogin] = useState(false)
    const email = useRef(null);
    const [error,setError] = useState('')
    const password = useRef(null);
    const [disabled,setDisabled] = useState(false)
    const [blocked,setBlocked] = useState(false)

    const handleLogin = async (e) => {
        e.preventDefault();
        setDisabled(true)
        try {
            const response = await login({
                email: email.current.value,
                password: password.current.value
            });
            setDisabled(false)
        } catch (error) {
            setDisabled(false)
           if(error.status === 401){
            setErrorLogin(true)
            setError('Login ou senha incorretas')
           }
           if(error.status === 403){
            setErrorLogin(true)
            console.log(error)
            setBlocked(blocked);
            setTwofa(false);
            setError(error.response.data.error)
           }
        }
    };
console.log(process.env.REACT_APP_API_URL)
    return (
        <div className="relative w-full h-screen flex justify-center items-center bg-[#171717]">
            <div className='linear-geadient rounded-[20px] pb-[1px] px-[1px] md:w-[25%]'>
                <div className='w-full bg-[#1D1D1D] px-8 rounded-[20px] p-[1px] py-4'>
                    <div className='w-full flex justify-center mt-6'>
                        <img width={100} src={Logo} alt="Logo" />
                    </div>
                    <div className='w-full flex flex-col text-white mt-4 gap-4'>
                       {errorLogin && <p className='text-[12px] text-[red]'>{error}</p>}
                        <form className='flex flex-col text-white mt-4 gap-4' onSubmit={handleLogin}>
                            <div className='flex gap-2 text-[13px] flex-col'>
                                <label>*Email</label>
                                <input required ref={email} className='h-[35px] bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none' placeholder='digite seu email' />
                            </div>
                            <div className='flex gap-2 text-[13px] flex-col'>
                                <label>*Senha</label>
                                <input required ref={password} type="password" className='h-[35px] bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none' placeholder='digite sua senha' />
                            </div>
                            <button type="submit" className='bg-[#478DF8] text-[13px] cursor-pointer rounded-[8px] p-2'>{!disabled?'Fazer Login': 'Logando'}</button>
                        </form>
                        <p className='text-[13px] w-full flex justify-center gap-2'>Não tem uma conta? <a onClick={() => { window.location.href = '/#/register' }} className='cursor-pointer text-[#478DF8]'>Registre-se</a></p>
                    </div>
                </div>
            </div>
            <TwoFactorModalLogin blocked={blocked} handleLogin={handleLogin} />
        </div>
    );
};

export default LoginPage;